/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  RewardDelegate,
  RewardDelegateInterface,
} from "../RewardDelegate";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "truster",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "beneficiary",
        type: "address",
      },
    ],
    name: "BeneficiaryCleared",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "truster",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "beneficiary",
        type: "address",
      },
    ],
    name: "BeneficiarySet",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address",
      },
    ],
    name: "clearBeneficiary",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getBeneficiaryAndQualifiedMultiplier",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "truster",
        type: "address",
      },
    ],
    name: "getBeneficiaryCandidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "candidate",
        type: "address",
      },
    ],
    name: "setBeneficiaryCandidate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "truster",
        type: "address",
      },
    ],
    name: "updateBeneficiary",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class RewardDelegate__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<RewardDelegate> {
    return super.deploy(overrides || {}) as Promise<RewardDelegate>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): RewardDelegate {
    return super.attach(address) as RewardDelegate;
  }
  connect(signer: Signer): RewardDelegate__factory {
    return super.connect(signer) as RewardDelegate__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RewardDelegateInterface {
    return new utils.Interface(_abi) as RewardDelegateInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RewardDelegate {
    return new Contract(address, _abi, signerOrProvider) as RewardDelegate;
  }
}
